const mediasoup = require("mediasoup-client");

//const mediasoup = window.mediasoupClient;

let isWebcam;
let isAudio = false;
let device;
var previewLive = false;
let consumeTransport;
let produceCallback;
let consumerCallback;
let socket;
let remoteStream;
let remoteVideo;
let remoteMessage;
let produtorPlay = "";

//let producer;
let deviceId;
let deviceIdAudio;
let msToken = "";
let msConectado = false;

let msUrl = "";
let msRoutes = [];
let msTipo = "consumidor";

export const apiMS = {
  getToken() {
    return msToken;
  },
  getConectado() {
    return msConectado;
  },
  getUrl() {
    return msUrl + "/ws";
  },
  getRoutes() {
    return msRoutes;
  },
  getTipo() {
    return msTipo;
  },
  setToken(token) {
    msToken = token;
  },
  setUrl(url) {
    msUrl = url;
  },
  setConectado(conectado) {
    msConectado = conectado;
  },
  setRoutes(routes) {
    msRoutes = routes;
  },
  setTipo(tipo) {
    msTipo = tipo;
  },
  keepAlive() {
    var thisCall = this;
    setTimeout(function() {
      try {
        if (msConectado) {
          socket.send(
            JSON.stringify({ type: "keepAlive", token: thisCall.getToken() })
          );
        }
      } catch (error) {
        console.log("Erro keepAlive:", error);
      }
      thisCall.keepAlive();
    }, 5000);
  },
  connect(connectConfig) {
    var thisCall = this;

    remoteVideo = document.getElementById("msPlayVideo");
    remoteMessage = document.getElementById("frameMessageRemote");

    socket = new WebSocket(thisCall.getUrl());
    socket.addEventListener("open", () =>
      //ev
      {
        //console.log("socket connected!", ev);

        connectConfig.startMsg =
          connectConfig.startMsg && connectConfig.startMsg == false
            ? false
            : true;

        if (connectConfig.startMsg) {
          const msg = {
            type: "getRouterRtpCapabilities",
            token: thisCall.getToken()
          };
          const resp = JSON.stringify(msg);
          socket.send(resp);
        }

        thisCall.keepAlive();
      }
    );

    socket.addEventListener("message", async function(event) {
      const jsonValidation = thisCall.IsJsonString(event.data);
      if (!jsonValidation) {
        console.log("invalid json");
        return;
      }
      let resp = JSON.parse(event.data);
      //console.log("checking", resp);
      switch (resp.type) {
        case "hasPublisher":
          //bntSub.disabled = false;
          break;
        case "routerCap":
          thisCall.onRouterCap(resp);
          if (connectConfig.subscribe) {
            thisCall.subscribe();
          }
          thisCall.setConectado(true);
          break;
        case "pubTransportCreated":
          thisCall.onPubTransportCreated(resp);
          break;
        case "pubConnected":
          //thisCall.onPubConnected();
          break;
        case "published":
          thisCall.onPublished(resp);
          break;
        case "subTransportCreated":
          thisCall.onsubTransportCreated(resp);
          break;
        case "subConnected":
          thisCall.onSubConnected(resp);
          break;
        case "resumed":
          //console.log(resp.data);
          break;
        case "subscribed":
          if (resp.data.video == null) {
            setTimeout(() => {
              produtorPlay = "notproduter";
              //thisCall.connect({ subscribe: true });
              thisCall.keepAlive();
            }, 5000);
          } else {
            thisCall.onSubscribed("video", resp.data.video);

            if (resp.data.audio !== null) {
              thisCall.onSubscribed("audio", resp.data.audio);
            }
          }

          break;
        case "closeSubscribed":
          remoteVideo.style.display = "none";
          if (remoteMessage !== null) {
            remoteMessage.style.display = "block";
          }

          break;
        case "keepAlive":
          if (resp.data.status == true) {
            if (produtorPlay == "") {
              produtorPlay = resp.data.produtorPlay;
            }

            if (resp.data.produtorPlay !== produtorPlay) {
              if (resp.data.produtorPlay !== "") {
                produtorPlay = resp.data.produtorPlay;

                if (msTipo == "produtor") {
                  //* Bloqueia o frame do produtor quando trocou o produtor
                  var frameTransmissao = document.getElementsByClassName(
                    "frameTransmissao"
                  );

                  if (frameTransmissao.length > 0) {
                    frameTransmissao[0].style.opacity = "0.4";
                    frameTransmissao[0].style["pointer-events"] = "none";
                  }
                }

                if (msTipo == "consumidor") {
                  thisCall.subscribe();
                }
              }
            }
          }

          //console.log("Retorno Keep Alive: ", resp);

          break;
        default:
          // console.log("default: ", resp)
          break;
      }
    });

    socket.onclose = function(e) {
      console.log(
        "Socket is closed. Reconnect will be attempted in 1 second.",
        e.reason
      );

      if (msConectado) {
        setTimeout(function() {
          var connectConfigReconnect = connectConfig;
          connectConfig.startMsg = false;
          thisCall.connect(connectConfigReconnect);
        }, 1000);
      }
    };

    socket.onerror = function(err) {
      console.error(
        "Socket encountered error: ",
        err.message,
        "Closing socket"
      );
      socket.close();
    };
  },
  publish(dispositivoVideo, dispositivoAudio, dispositivoPreview) {
    isWebcam = dispositivoVideo == "screen" ? false : true;
    isAudio = dispositivoAudio == "false" ? false : true;
    previewLive = dispositivoPreview;
    deviceId = dispositivoVideo;
    deviceIdAudio = dispositivoAudio;

    console.log("DEVICE USUARIO", device);
    const msg = {
      type: "createProducerTransport",
      forceTcp: false,
      rtpCapabilities: device.rtpCapabilities,
      token: this.getToken()
    };
    const resp = JSON.stringify(msg);
    //console.log("sending create producer: ", msg);
    socket.send(resp);
  },
  subscribe() {
    //bntSub.disabled = true;
    const msg = {
      type: "createConsumerTransport",
      forceTcp: false,
      //sala: canalConsumidor.value
      token: this.getToken()
    };
    const resp = JSON.stringify(msg);
    //console.log("sending create producer: ", msg);
    socket.send(resp);
  },
  disconnect() {
    socket.close();
    isWebcam = null;
    isAudio = false;
    device = null;
    consumeTransport = null;
    produceCallback = null;
    consumerCallback = null;
    socket = null;
    remoteStream = null;
    remoteVideo = null;

    //producer = null;
    deviceId = null;
    deviceIdAudio = null;
    msToken = "";
    msConectado = false;
    msUrl = "";
  },
  onRouterCap(resp) {
    //console.log("routercap hit!");
    this.loadDevice(resp.data);
  },
  onSubConnected() {
    // resp
    //console.log("on pub connected!", resp);
    consumerCallback();
  },
  async onSubscribed(fonte, item) {
    var { producerId, id, kind, rtpParameters } = item;

    let codecOptionsV = {};
    const consumer = await consumeTransport.consume({
      id,
      producerId,
      kind,
      rtpParameters,
      codecOptionsV
    });

    if (fonte == "video") {
      const stream = new MediaStream();
      stream.addTrack(consumer.track);
      remoteStream = stream;
    } else if (fonte == "audio") {
      remoteStream.addTrack(consumer.track);
    }

    produtorPlay = item.produtorPlay;

    return true;
  },
  async onPubTransportCreated(event) {
    var thisCall = this;

    const transport = device.createSendTransport(event.data);

    // create send transport
    transport.on("connect", async ({ dtlsParameters }, callback) => {
      const msg = {
        type: "connectProducerTransport",
        token: thisCall.getToken(),
        dtlsParameters
      };
      const resp = JSON.stringify(msg);

      socket.send(resp);
      callback();
    });

    // on produce
    transport.on(
      "produce",
      async ({ kind, rtpParameters, appData }, callback) => {
        const msg = {
          type: "produce",
          token: thisCall.getToken(),
          transportId: transport.id,
          fonte: appData.fonte,
          kind,
          rtpParameters
        };
        const resp = JSON.stringify(msg);
        socket.send(resp);
        produceCallback = callback;
      }
    );

    // transport connection state change
    transport.on("connectionstatechange", (state) => {
      switch (state) {
        case "connecting":
          //textPublish.innerHTML = "publishing...";
          break;

        case "connected":
          //console.log("transport connected!@");
          //localVideo.srcObject = stream;
          //textPublish.innerHTML = "published";
          break;

        case "failed":
          transport.close();
          break;

        default:
          break;
      }
    });
    let stream;
    try {
      var videoTrack;

      if (previewLive) {
        var canvasLive = document.getElementById("canvasLive");
        videoTrack = canvasLive.captureStream().getVideoTracks()[0];
      } else {
        stream = await thisCall.getUserMedia(transport, isWebcam);
        videoTrack = stream.getVideoTracks()[0];
      }

      const paramsVideo = { track: videoTrack, appData: { fonte: "video" } };

      await transport.produce(paramsVideo);

      if (isAudio) {
        const audioTrack = stream.getAudioTracks()[0];
        const paramsAudio = { track: audioTrack, appData: { fonte: "audio" } };

        await transport.produce(paramsAudio);
      }
    } catch (error) {
      console.log("get user media: ", error);
    }
  },
  onsubTransportCreated(event) {
    //console.log("on Sub transport created!", event);
    if (event.error) {
      console.log("on sub transport created error: ", event.error);
    }
    const transport = device.createRecvTransport(event.data);
    this.subTransportListen(transport);
  },
  async subTransportListen(transport) {
    var thisCall = this;
    consumeTransport = transport;
    transport.on("connect", ({ dtlsParameters }, callback) => {
      const msg = {
        type: "connectConsumerTransport",
        token: thisCall.getToken(),
        transportId: transport.id,
        dtlsParameters
      };
      const resp = JSON.stringify(msg);
      //console.log("sending connectConsumerTransport: ", msg);
      socket.send(resp);
      consumerCallback = callback;
    });

    transport.on("connectionstatechange", async (state) => {
      switch (state) {
        case "connecting":
          //console.log(state);
          //textSubscribe.innerHTML = "subscribing...";
          break;

        case "connected": {
          //console.log(remoteStream);
          remoteVideo.srcObject = remoteStream;
          remoteVideo.style.display = "block";
          if (remoteMessage !== null) {
            remoteMessage.style.display = "none";
          }

          const msg = {
            type: "resume",
            token: thisCall.getToken()
          };
          const resp = JSON.stringify(msg);
          //console.log("sending resume: ", msg);
          socket.send(resp);
          //textSubscribe.innerHTML = "subscribed";
          break;
        }

        case "failed":
          transport.close();
          //textSubscribe.innerHTML = "failed";
          //bntSub.disabled = false;
          break;

        default:
          break;
      }
    });

    const stream = this.consume(transport);
    return stream;
  },
  onPublished(resp) {
    produceCallback(resp.data.id);

    produtorPlay = resp.data.produtorPlay;

    for (var indiceRoute = 0; indiceRoute < msRoutes.length; indiceRoute++) {
      var msRoute = msRoutes[indiceRoute];
      this.publishRouteReplication(msRoute.instanceDest, msRoute.salaDest);
    }
  },
  async consume() {
    //transport
    const { rtpCapabilities } = device;
    const msg = {
      type: "consume",
      token: this.getToken(),
      rtpCapabilities
    };
    const resp = JSON.stringify(msg);
    //console.log("sending consume: ", msg);
    socket.send(resp);
    //console.log("transport", transport);
  },
  async loadDevice(routerRtpCapabilities) {
    try {
      device = new mediasoup.Device();
    } catch (e) {
      if (e.name === "UnsupportedError") {
        console.error("browser not supported");
      }
    }
    await device.load({ routerRtpCapabilities });
  },
  async getUserMedia(transport, isWebcam) {
    if (!device.canProduce("video")) {
      console.error("cannot produce video");
      return;
    }
    let stream;
    try {
      if (isWebcam) {
        var audioObject = true;

        if (deviceIdAudio !== "false") {
          audioObject = { deviceId: deviceIdAudio };
        }

        //stream = await navigator.mediaDevices.getUserMedia({ video: { width: { ideal: 1280, max: 3840 }, height: { ideal: 720, max: 2160 }, deviceId: deviceId }, audio: audioObject });
        //stream = await navigator.mediaDevices.getUserMedia({ video: {  width: { ideal: 9999 },  height: { ideal: 9999 }, deviceId: deviceId }, audio: audioObject });
        stream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: deviceId },
          audio: audioObject
        });
      } else {
        let streamScreen = await navigator.mediaDevices.getDisplayMedia({
          video: true
        });

        if (deviceIdAudio !== "false") {
          let streamAudio = await navigator.mediaDevices.getUserMedia({
            audio: { deviceId: deviceIdAudio }
          });
          streamScreen.addTrack(streamAudio.getAudioTracks()[0]);
        }

        return streamScreen;
      }
    } catch (err) {
      console.error("getUserMedia() failed:", err.message);
      throw err;
    }
    return stream;
  },
  IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  },
  publishRouteReplication(instanceDest, salaDest) {
    const msg = {
      type: "publishRouteReplication",
      token: this.getToken(),
      instanceDest: instanceDest,
      salaDest: salaDest
    };

    const resp = JSON.stringify(msg);
    socket.send(resp);
  },
  publishRouteRemoteReplication(
    instanceDest,
    salaDest,
    servidorFonte,
    eventoFonte
  ) {
    const msg = {
      type: "publishRouteRemoteReplication",
      token: this.getToken(),
      instanceDest: instanceDest,
      salaDest: salaDest,
      instanceFonte: servidorFonte,
      eventFonte: eventoFonte
    };

    const resp = JSON.stringify(msg);
    socket.send(resp);
  },
  closeProducer(sala) {
    const msg = {
      type: "closeProducerTransport",
      token: this.getToken(),
      sala: sala
    };

    const resp = JSON.stringify(msg);
    socket.send(resp);
  }
};
